<template>
    <div class="clinic-work-step-wrap section-space--ptb_120" id="works">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-wrapper text-center section-space--pb_90">
                        <h6 class="section-sub-title mb-20 font-weight--bold wow move-up">{{ $t('question') }}</h6>
                        <h2 class="section-title font-weight--blod wow move-up">{{ $t('title') }}</h2>
                    </div>
                </div>
            </div>
            <!-- clinic Process Step first Start -->
            <div class="clinic-work-process-step ">
                <div class="row">
                    <div class="col-lg-6 wow move-up">
                        <div class="clinic-work-step__media images-left-ml  text-center">
                            <img src="../../assets/img/features/aeroland-clinic-image-01.png" style="max-width: 400px;" class="img-fluid" alt="thumbnail">
                        </div>
                    </div>
                    <div class="col-lg-5 wow move-up">
                        <div class="clinic-work-process-step__content">
                            <div class="app-showcase__inner">
                                <div class="sub__title mb-20">
                                    <h6 class="font-weight--blod">{{ $t('step') }} 01</h6>
                                </div>
                                <h4 class="font-weight--bold">{{ $t('step1') }}</h4>
                                <div class="sub-text section-space--mb_40">
                                    {{ $t('detail1') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- clinic Process Step first End -->
            <!-- clinic Process Step second Start -->
            <div class="clinic-work-process-step section-space--pt_90">
                <div class="row">
                    <div class="col-lg-6 order-lg-1 order-2 wow move-up">
                        <div class="clinic-work-process-step__content">
                            <div class="app-showcase__inner">
                                <div class="sub__title mb-20">
                                    <h6 class="font-weight--blod">{{ $t('step') }} 02</h6>
                                </div>
                                <h4 class="font-weight--bold">{{ $t('step2') }}</h4>
                                <div class="sub-text section-space--mb_40">
                                    {{ $t('detail2') }}
                                </div>
<!--                                 <div class="button-group-wrap">
                                    <a href="#" class="image-btn img-fluid mr-2"><img src="../../assets/img/icons/aeroland-black-button-google-play.jpg" alt="thumbnail"></a>
                                    <a href="#" class="image-btn img-fluid"><img src="../../assets/img/icons/aeroland-button-app-store-dark.jpg" alt="thumbnail"></a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 order-lg-2 order-1 wow move-up">
                        <div class="clinic-work-step__media images-right-mr  text-center">
                            <img src="../../assets/img/features/aeroland-clinic-image-03.png" style="max-width: 400px;" class="img-fluid" alt="thumbnail">
                        </div>
                    </div>

                </div>
            </div>
            <!-- clinic Process Step second End -->
            <!-- clinic Process Step Three Start -->
            <div class="clinic-work-process-step  section-space--pt_90">
                <div class="row">
                    <div class="col-lg-6 wow move-up">
                        <div class="clinic-work-step__media images-left-ml  text-center">
                            <img src="../../assets/img/features/aeroland-clinic-image-02.png" style="max-width: 400px;" class="img-fluid" alt="thumbnail">
                        </div>
                    </div>
                    <div class="col-lg-6 wow move-up">
                        <div class="clinic-work-process-step__content">
                            <div class="app-showcase__inner">
                                <div class="sub__title mb-20">
                                    <h6 class="font-weight--blod">{{ $t('step') }} 03</h6>
                                </div>
                                <h4 class="font-weight--bold">{{ $t('step3') }}</h4>
                                <div class="sub-text section-space--mb_40">
                                    {{ $t('detail3') }}
                                </div>
                                <div class="btn-sowcase">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- clinic Process Step Three End -->
        </div>
    </div>
</template>

<script>
    export default{
        name: 'ClinicWorkStep',
    };
</script>

<i18n>
{
  "en": {
    "question": "How Dyjest works?",
    "title": "Simple",
    "step": "STEP",
    "step1": "Create your account",
    "detail1": " Create an account in a matter of seconds. ",
    "step2": "Patients download the App",
    "detail2": "The Dyjest app will be available for iOS and Android. Once the app is installed, patients can give you access to their data. ",
    "step3": "Get reliable data before appointments",
    "detail3": "Get a detailed report before every consultation."
  },
  "fr": {
    "question": "Comment ça marche?",
    "step": "ETAPE",
    "title": "Simple comme bonjour.",
    "step1": "Créez un compte.",
    "detail1": "Créez un compte en quelques secondes.",
    "step2": "Vos patients téléchargent l'application",
    "detail2": "L'application Dyjest sera disponible sur iOS et Android. Une fois l'application installée, les patients peuvent vous donner accès à leurs données.",
    "step3": "Accédez à un rapport fiables avant vos rendez-vous",
    "detail3": "Obtenez un rapport détaillé avant chaque consultation."
  }
}
</i18n>